import { ModalOrOffcanvas } from '../modal';
import { ContactForm, InitForm } from '../contact-form';
import i18n from '../i18n';
import * as template from 'smg/template';
import { Copy } from 'smg/clipboard';
import { Success } from 'smg/toast';

main();

function main() {
    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $formTemplate = document.querySelector('#contact-form-template') as HTMLTemplateElement;
    ContactForm($form, $formTemplate);

    const $formOpen = document.querySelector<HTMLButtonElement>('#contact-us-form-open');

    $formOpen?.addEventListener('click', () => {
        const $modalFormTemplate = document.querySelector('#contact-form-modal-template') as HTMLTemplateElement;
        const $body = template.Clone($modalFormTemplate).firstElementChild as HTMLElement;

        new ModalOrOffcanvas({
            title: i18n('contactSendUsANote'),
            body: $body,
            appendClassBySelector: {
                '.modal-footer': 'd-none',
                '.offcanvas-footer': 'd-none',
            },
            onSubmit: InitForm($body, 'modal-').submit,
        });
    });

    const $copyAddressBtn = document.querySelector<HTMLButtonElement>('#copy-address-btn');
    $copyAddressBtn?.addEventListener('click', () => {
        const $card = $copyAddressBtn.closest('.card');
        const $addressEl = $card?.querySelector<HTMLElement>('.text-primary.fw-semibold');
        if (!$addressEl) {
            return;
        }
        const address = $addressEl.innerText;
        Copy(address);
        Success(i18n('contactCardsCopyAddressSuccess'));
    });
}
